<template>
  <div class="home-container">
    <div class="header">
      <div class="header-select">
        <el-button @click="IsSelect" type="primary" plain
          >选择入驻小镇
          <i class="el-icon-sort"></i>
        </el-button>
        <transition name="myselect">
          <div v-show="isselect" class="header-select-border">
            <el-input
              placeholder="请输入关键词搜索"
              prefix-icon="el-icon-search"
              v-model="inputs"
              @input="InputTowns"
              clearable
            >
            </el-input>
            <div class="border-content" v-for="(item, key, index) in selection">
              <div class="border-content-title">{{ key }}</div>
              <div class="border-content-names">
                <div
                  class="border-content-name"
                  v-for="a in item"
                  @click="GoToLogin(a.ftCode)"
                >
                  {{ a.ftName }}
                </div>
              </div>
            </div>
          </div>
        </transition>
      </div>
      <div class="header-title">
        <transition name="text1">
          <div class="header-title-text1">湘江私募基金管理服务平台</div>
        </transition>
        <transition name="text2">
          <div class="header-title-text2">
            湘江基金小镇是湖南首个基金小镇，2017年7月26日由湖南省政府授牌成立
          </div>
        </transition>
        <transition name="text3">
          <div class="header-title-text3">资本高地 产融平台</div>
        </transition>
      </div>
      <el-image
        class="header-carousel"
        style="width: 100%; height: 100%; filter: brightness(75%)"
        :src="headerImage[0]"
        fit="cover"
      >
      </el-image>
    </div>
    <div class="content">
      <div class="content-icon">
        <!-- <el-col class="content-icon-col" :span="6" v-for="item in iconImage">
          <el-image :src="item.url"></el-image>
          <div class="text">{{ item.text }}</div>
        </el-col> -->
      </div>
      <div class="content-container">
        <div class="content-container-left">
          <div class="left-title">小镇简介</div>
          <div class="left-content">
            <div class="left-content-name">
              {{ containers[containerIndex].ftName }}
            </div>
            <div class="left-content-discribe">
              {{ containers[containerIndex].introduction }}
            </div>
          </div>
          <div class="left-href" @click="LearnMore">
            查看详情
            <i class="el-icon-sort-down"></i>
          </div>
          <div class="left-button">
            <el-button
              class="left-button-l"
              icon="el-icon-arrow-left"
              @click="PageLeft"
            ></el-button>
            <el-button
              class="left-button-r"
              type="primary"
              @click="PageRight"
              icon="el-icon-arrow-right"
            ></el-button>
          </div>
        </div>
        <div class="content-container-right">
          <img :src="containers[containerIndex].imgStorePath" fit="cover" />
          <!-- <div slot="error" class="image-slot">
              <i class="el-icon-picture-outline"></i>
            </div>
          </el-image> -->
        </div>
      </div>
    </div>
    <div class="footer">
      <span>Copyright © 2026 湖南湘江基金小镇投资管理有限公司</span>
      <a
        href="https://beian.miit.gov.cn/"
        target="_blank"
        rel="nofollow noopener"
        >湘ICP备20010355号-4</a
      >
    </div>
  </div>
</template>
<script>
import {
  getAllTownList,
  getTownList,
  // imgSrcGetBase64,
  imgIndexDB,
} from "@/common/js/api.js";
export default {
  name: "Homepage",
  components: {},
  data() {
    return {
      headerImage: [require("@/assets/images/homepage/page1.jpg")],
      iconImage: [
        {
          text: "安全",
          url: require("@/assets/images/homepage/icon/01.png"),
        },
        {
          text: "友好",
          url: require("@/assets/images/homepage/icon/02.png"),
        },
        {
          text: "高效",
          url: require("@/assets/images/homepage/icon/03.png"),
        },
        {
          text: "多元",
          url: require("@/assets/images/homepage/icon/04.png"),
        },
      ],
      containers: [
        {
          ftName: "湘江基金小镇",
          introduction:
            "湘江基金小镇整体位于湖南金融中心范围内，是金融中心的重要业态之一。小镇由湖南湘江基金小镇投资管理有限公司负责运营。选址湘江沿线，东临湘江，西至滨江景观道，南至银盆岭大桥，北至北津城路。总规划面积800亩，建筑规模24万㎡，沿江岸线4km，绿地率约55%，是金融中心环境最好的地段",
          linkAddress: "https://www.xjfundtown.cn/",
          photo: require("@/assets/images/homepage/page1.jpg"),
        },
      ],
      containerIndex: 0,
      inputs: "",
      selection: {},
      towns: {},
      isselect: false,
    };
  },
  methods: {
    PageLeft() {
      if (this.containerIndex === 0) {
        this.containerIndex = this.containers.length - 1;
      } else {
        this.containerIndex -= 1;
      }
    },
    PageRight() {
      if (this.containerIndex === this.containers.length - 1) {
        this.containerIndex = 0;
      } else {
        this.containerIndex += 1;
      }
    },
    LearnMore() {
      window.open(this.containers[this.containerIndex].linkAddress);
    },
    IsSelect() {
      this.isselect = !this.isselect;
    },
    InputTowns() {
      if (this.inputs == "") {
        this.selection = this.towns;
      } else {
        let ready = {};
        for (const key in this.towns) {
          let a = [];
          let b = false;
          this.towns[key].forEach((element) => {
            if (element.ftName.includes(this.inputs)) {
              a.push(element);
              b = true;
            }
          });
          if (b === true) {
            ready[key] = a;
          }
        }
        this.selection = ready;
      }
    },
    async GetAllTowns() {
      const { result } = await getAllTownList();
      console.log("result1:", result);
      this.towns = result;
      this.selection = result;
    },
    // async GetAllTownsHome (val) {
    //   const { result } = await getPageConfigListHome(val);
    //   console.log("result2:", result);
    // },
    GoToLogin(val) {
      this.$router.push({
        path: "/Login/Login",
        query: {
          TownCode: val,
        },
      });
    },
    // async GetAllTownsHome (val) {
    //   const result2 = await getPageConfigListHome(val);
    //   console.log("result2:", result2);
    // }
    async getTown() {
      const res = await getTownList();
      this.containers = res.result;
      this.containers = this.containers.filter((val) => {
        return val.ftCode && val.ftName && val.imgStorePath && val.linkAddress;
      });
      for (let i = 0; i < this.containers.length; i++) {
        const element = this.containers[i];
        imgIndexDB(element.imgStorePath).then((res) => {
          console.log(res);
          this.containers[i].imgStorePath = res;
          // let myblob
          // blobToDataURI(res, result1 => {
          //   myblob = dataURItoBlob(result1)
          //   console.log("myblob", myblob)
          //   const result = URL.createObjectURL(myblob);
          //   this.containers[i].imgStorePath = result;
          // })

          // function dataURItoBlob(dataURI) {
          //   var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]; // mime类型
          //   var byteString = atob(dataURI.split(',')[1]); //base64 解码
          //   var arrayBuffer = new ArrayBuffer(byteString.length); //创建缓冲数组
          //   var intArray = new Uint8Array(arrayBuffer); //创建视图

          //   for (var i = 0; i < byteString.length; i++) {
          //     intArray[i] = byteString.charCodeAt(i);
          //   }
          //   return new Blob([intArray], { type: mimeString });
          // }
          // function blobToDataURI(blob, callback) {
          //   var reader = new FileReader();
          //   reader.onload = function (e) {
          //     callback(e.target.result);
          //   }
          //   reader.readAsDataURL(blob);
          // }
        });
      }
    },
  },
  mounted() {
    this.GetAllTowns();
    this.getTown();
    // this.indexDB()
  },
};
</script>
<style scoped lang="scss">
.header {
  position: relative;
  width: 100vw;
  height: 100vh;

  &-select {
    position: absolute;
    top: 3.5vh;
    right: 4.5vw;
    text-align: right;

    ::v-deep .el-button {
      margin-bottom: 10px;

      .el-icon-sort {
        -webkit-transform: rotate(90deg);
        margin-left: 6px;
      }
    }

    &-border {
      width: 320px;
      height: 240px;
      border-radius: 4px;
      padding: 20px;

      ::v-deep .el-input__inner {
        background: #f2f4f7;
        color: #999999ff;
      }

      background-image: linear-gradient(#ffffff, #e0ffff);

      .border-content {
        margin-top: 24px;

        &-title {
          font-size: 14px;
          font-family: Alibaba;
          text-align: left;
          color: #999999;
          line-height: 20px;
        }

        &-names {
          display: flex;
          overflow: auto;
        }

        &-name {
          width: 50%;
          margin-top: 8px;
          font-size: 16px;
          font-family: Alibaba;
          text-align: left;
          color: #191818;
          line-height: 22px;
          cursor: pointer;

          &:hover {
            color: #008fff;
            text-decoration: underline;
          }
        }
      }
    }

    z-index: 2;
  }

  &-title {
    position: absolute;
    left: 20vw;
    right: 20vw;
    top: 35.125vh;

    &-text1 {
      z-index: 1;
      position: relative;
      font-size: 3.875vw;
      font-weight: 700;
      font-family: Alibaba, AlibabaB;
      text-align: center;
      color: #ffffff;
      line-height: 5.813vw;
      letter-spacing: 0.125vw;
      text-shadow: 0px 2px 6px 0px rgba(0, 35, 74, 0.2);
    }

    &-text2 {
      z-index: 1;
      position: relative;
      margin-top: 2vw;
      font-size: 2vh;
      font-weight: 500;
      font-family: Alibaba, AlibabaB;
      text-align: center;
      color: #ffffff;
      line-height: 3vh;
      text-shadow: 0px 2px 6px 0px rgba(0, 35, 74, 0.2);
    }

    &-text3 {
      z-index: 1;
      position: relative;
      margin-top: 3.5vw;
      font-size: 2vw;
      font-weight: 500;
      font-family: Alibaba, AlibabaB;
      text-align: center;
      color: #ffffff;
      line-height: 3vw;
      letter-spacing: 0.333vh;
      text-shadow: 0px 2px 6px 0px rgba(0, 35, 74, 0.2);
    }

    z-index: 1;
  }

  &-carousel {
    position: absolute;
    height: 100%;
    width: 100%;

    ::v-deep .el-carousel__container {
      height: 100%;
    }

    z-index: 0;
  }
}

.content {
  padding-bottom: 86px;

  &-icon {
    margin-top: 40px;
    margin-bottom: 100px;
    padding: 0 11.25vw;
    display: flex;
    overflow: auto;

    &-col {
      text-align: center;

      .text {
        font-size: 20px;
        font-family: Alibaba, AlibabaM;
        font-weight: 500;
        text-align: center;
        color: #333333;
        line-height: 30px;
      }
    }
  }

  &-container {
    padding: 0 11.25vw;
    height: 503px;
    display: flex;
    overflow: auto;

    &-left {
      height: 503px;
      width: 35%;
      padding-right: 57.6px;
      display: flex;
      overflow: auto;
      flex-direction: column;

      .left-title {
        width: 139.2px;
        height: 56.4px;
        background: #008fff;
        font-size: 18px;
        font-family: Alibaba;
        font-weight: 400;
        text-align: center;
        color: #ffffff;
        line-height: 56.4px;
      }

      .left-content {
        margin-top: 114px;

        &-name {
          font-size: 40px;
          font-family: Alibaba, AlibabaB;
          font-weight: 700;
          text-align: left;
          color: #333333;
        }

        &-discribe {
          margin-top: 28.8px;
          height: 112px;
          font-size: 15px;
          line-height: 18px;
          font-family: Alibaba;
          font-weight: 400;
          text-align: left;
          color: #999999;
        }
      }

      .left-href {
        cursor: pointer;
        margin-top: 38.4px;
        font-size: 14px;
        font-family: Alibaba;
        font-weight: 400;
        text-align: left;
        color: #008fff;
        line-height: 14px;

        .el-icon-sort-down {
          -webkit-transform: rotate(90deg) scaleY(-1);
        }

        &:hover {
          text-decoration: underline;
        }
      }

      .left-button {
        flex: 1;
        display: flex;
        overflow: auto;
        align-items: flex-end;

        ::v-deep .el-button {
          width: 40px;
          height: 40px;
          border-radius: 0;
          padding: 0;
        }

        ::v-deep .el-button + .el-button {
          margin-left: 104px;
        }
      }
    }

    &-right {
      height: 503px;
      width: 65%;

      img {
        height: 100%;
        width: 100%;
        object-fit: cover;
      }
    }
  }
}

.home-container::-webkit-scrollbar {
  display: none;
}

//动画
.myselect-enter,
.myselect-leave-to {
  opacity: 0;
}

.myselect-enter-to,
.myselect-leave {
  opacity: 1;
}

.myselect-enter-active,
.myselect-leave-active {
  transition: all 1s;
}

.footer {
  background-color: #f5f5f5;
  padding: 20px 0;
  text-align: center;
  font-size: 14px;
  color: #666;

  span {
    margin-right: 20px;
  }

  a {
    color: #666;
    text-decoration: none;

    &:hover {
      color: #008fff;
      text-decoration: underline;
    }
  }
}
</style>
